import Vue from 'vue';
import { VPopover, VTooltip, VClosePopover } from 'v-tooltip';

VTooltip.options.defaultPlacement = 'bottom';

Vue.directive('tip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-tip', VPopover);
